import { MapperBase } from "@utilities/mapper-base";
import { ReportResponseResource } from "./resource/report-response.resource";

export class ReportResponseResourceToReviewedDocumentCountMapper extends MapperBase<ReportResponseResource, number> {
    map(source: ReportResponseResource): number {
        const dataItem = source?.data.find(item => item?.pivot === 'Checked');
        return dataItem ? Number(dataItem.total) : 0;
    }
}